/**
 * This class handles single product page funtionality.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class SingleProduct
 */
export default class SingleProduct {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.$print           = $( '#js-single-product-print' );
        this.$tabBtn          = $( '.js-single-product-tab-btn' );
        this.$tab             = $( '.js-single-product-tab' );
        this.$variationSelect = $( '.js-single-product-variation-select' );
        this.$sku             = $( '.js-single-product-sku' );
        this.$image           = $( '#js-single-product-image' );
        this.$shortDesc       = $( '.js-single-product-short-desc' );
        this.$cartBtn         = $( '.js-add-to-cart' );
        this.$form            = $( '.js-add-to-cart-ajax-form' );
        this.$variations      = this.$form.data( 'variations' );
        this.$vartiationId    = $( '#js-product-id' );
        this.$vartiationPrice = $( '#js-variatation-price' )

        // Tabs.
        this.tabList  = {
            description: $( '#js-single-product-tab-description' ),
            qualities: $( '#js-single-product-tab-qualities' ),
            catalogs: $( '#js-single-product-tab-catalogs' ),
            responsibility: $( '#js-single-product-tab-responsibility' ),
        };

        this.$modaal = $( '.single-product-gallery' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Toggle tab visibility.
        this.$tabBtn.on( 'click', ( e ) => {
            this.toggleTab( e );
        });

        this.$print.on( 'click', () => {
            window.print();
        });

        this.$variationSelect.on( 'change', () => {
            this.handleVariationChange();
            this.handleAddToCartButton();
            this.handleVariationPrice();
        });
    }

    /**
     * Initialize gallery.
     */
    initGallery() {
        this.$modaal.modaal({
            type: 'image',
            after_open: () => this.afterModaalOpen() // eslint-disable-line camelcase
        });
    }

    /**
     * Initialize tabs.
     */
    initTabs() {

        // If description tab not found, show qualities tab.
        // If description tab and qualities tab not found. show videos tab.
        if ( ! this.tabList.description.length ) {
            this.tabList.qualities.show();
        } else if ( ! this.tabList.qualities.length ) {
            this.tabList.catalogs.show();
        }
    }

    /**
     * Toggle tab visibility.
     */
    toggleTab( e ) {

        // Hide all tabs.
        this.$tab.hide();

        // Remove active class.
        this.$tabBtn.removeClass( 'active' );

        // Add active class.
        $( e.target ).addClass( 'active' );

        // Get the target tab.
        const target = $( e.target ).data( 'target' );

        // Find the target tab from the tab list and show it.
        if ( target in this.tabList ) {
            this.tabList[ target ].show();
        }
    }

    handleVariationChange() {

        // Get all select values.
        const values = $.map( this.$variationSelect, ( select ) => {
            return $( select ).val();
        });

        if ( values ) {

            // Loop through every variation and check if selected values matches.
            $.each( productVariations, ( index, variation ) => {

                // Check if variation product matches with selected attributes.
                const isEvery = values.every( ( value ) => {
                    return index.indexOf( value ) > -1;
                });

                // If selected attributes matches with variation product, change data.
                if ( isEvery && values.length === variation.variationsCount ) {
                    this.variation = variation;
                    this.$sku.text( variation.sku );
                    this.$shortDesc.html( variation.shortDesc );

                    // If variation product has image, change it.
                    if ( variation.image_src ) {

                        // Create new image element.
                        const img = $( '<img />', {
                            src: variation.image_src,
                            alt: variation.image_alt ? variation.image_alt : ''
                        });

                        // Change image html.
                        this.$image.html( img );

                        // Update image link's href value for Modaal.
                        this.$image.attr( 'href', variation.image_src );
                    }

                    // Loop through attributes and show variation specific attributes.
                    if ( variation.attributes ) {
                        $.each( variation.attributes, ( key, value ) => {
                            key = key.replace( 'attribute_', '' );
                            key = key.replace( 'pa_', '' );

                            $( `#js-attribute-${key}-value` ).text( value );
                        });
                    }

                    // No need to loop anymore, we found our product.
                    return false;
                } else {
                    this.$sku.text( '-' );
                    this.$shortDesc.html( variation.shortDescDefault );
                }
            });
        }
    }

    /**
     * Shows the price depending on variation selection.
     *
     * @return {void}
     */
    handleVariationPrice() {
        const prices = this.$form.data( 'prices' );
        const selectedVariation = $( '#js-product-id' ).val();

        if ( ! prices || ! selectedVariation ) {
            return;
        }

        this.$vartiationPrice.show().html( prices[ selectedVariation ] );
    }

    /**
     * Add to cart button is disabled until all select fields has value.
     * Populate variation product id from json.
     */
    handleAddToCartButton() {
        let allSelected = true;
        let allValues   = '';

        this.$variationSelect.each( function() {
            allValues = allValues + this.options[this.selectedIndex].value;
            if ( ! this.value ) {
                allSelected = false;
            }
        });

        // Check that all combinations are selected and behind combinations there is a product.
        if ( allSelected && this.$variations[allValues] ) {
            this.$vartiationId.val( this.$variations[allValues] ).trigger( 'change' );
            this.$cartBtn.removeAttr( 'disabled' );
        } else {
            this.$vartiationId.val( '' );
            this.$cartBtn.attr( 'disabled', 'disabled');
        }
    }


    /**
     * Handle custom modal functionality when modal has opened.
     */
    afterModaalOpen() {

        // Find the modaal container and get its width when modal has opened.
        const $container = $( '.modaal-container' );
        const containerWidth = $container.width();

        $container.on( 'click', function( e ) {

            // Get the X position inside modal container.
            const posX = e.pageX -  $( this ).offset().left;

            // If position is left side, trigger 'previous' button click.
            // Otherwise trigger 'next' button click.
            if ( posX > 0 && posX < containerWidth / 2 ) {
                $( '#modaal-gallery-prev' ).trigger( 'click' );
            } else if ( posX > containerWidth / 2 && posX < containerWidth ) {
                $( '#modaal-gallery-next' ).trigger( 'click' );
            }
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.initGallery();
        this.initTabs();
    }
}
